/**
 * Drill down an object to get the value of a key
 * @param {Object} drillObj - object to drill
 * @param {Array} keys - array of keys to drill
 * @returns {Object} - value of the key
 * @example
 * const drillObj = {
 *  a: {
 *   b: {
 *   c: 'd'
 *  }
 * }
 * };
 * const keys = ['a', 'b', 'c'];
 * const result = drillObject(drillObj, keys);
 */
const drillObject = (drillObj, keys) => {
  let obj = { ...drillObj };
  let found = false;

  // while key esists in drillKeys, keep drilling
  while (found === false) {
    let foundInLoop = false;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      if (obj[key]) {
        obj = obj[key];
        foundInLoop = true;
      }
    }

    if (!foundInLoop) {
      found = true;
    }
  }

  return obj;
};

export default drillObject;
